import { render, staticRenderFns } from "./kgriditem.vue?vue&type=template&id=1508c5ed&scoped=true&"
import script from "./kgriditem.vue?vue&type=script&lang=js&"
export * from "./kgriditem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508c5ed",
  null
  
)

export default component.exports